module.exports = __webpack_public_path__ + "static/media/tornado-icon.b42db6b4.svg";